import { useState, useEffect } from 'react';

interface MarketStatusData {
  isOpen: boolean;
  sessionPhase: string;
  nextEvent: string;
  nextEventTime: string;
  currentTime: string;
}

export function useMarketStatus() {
  const [data, setData] = useState<MarketStatusData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await fetch(`${import.meta.env.VITE_API_URL}/api/market/status`);
        const json = await res.json();
        if (json.success) setData(json.data);
      } catch {
        // silent fail
      } finally {
        setLoading(false);
      }
    };
    fetchStatus();
    const interval = setInterval(fetchStatus, 60000);
    return () => clearInterval(interval);
  }, []);

  return { data, loading };
}
